.page {
  background: #fff;
  padding: var(--page-pad-y) var(--page-pad-x);
}

.layout {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.sidebar { min-width: 0; }

.main { min-width: 0; }

.pager {
  display: flex;
  justify-content: center;
  padding: 32px 0 0;
}

/* Layout flips at the container level (not viewport) so the same
   stacking happens on iPad mini landscape, Pixel 7 landscape, and a
   narrow desktop window — anywhere the layout container itself can't
   afford the sidebar. */
.layoutWrap { container-type: inline-size; container-name: itemList; }

@container itemList (max-width: 760px) {
  .layout { grid-template-columns: 1fr; gap: 16px; }
  .sidebar { display: none; }
}

/* Portrait phones — squeeze the grid toward the center with extra
   side padding so the page has clear negative space framing the
   merchandise. */
@media (max-width: 540px) and (orientation: portrait) {
  .page { padding: 12px clamp(20px, 7vw, 36px) 0; }
  .main { max-width: 92%; margin: 0 auto; }
}
